<template>
  <fieldset>
    <b-field
        :label="$t('chapter7.q01.title')"
        :type="
          store.getFieldError('datenweitergabe', `datenUebertragung.${index}.empfaenger`)
            ? 'is-danger'
            : ''
        "
        :message="store.getFieldError('datenweitergabe', `datenUebertragung.${index}.empfaenger`)"
      >
        <b-input
          :required="true"
          :placeholder="
            partnerInternExtern === 'intern'
              ? $t('chapter7.q01.placeholder-intern')
              : $t('chapter7.q01.placeholder-extern')
          "
          v-model="ziel.empfaenger"
          @blur="save"
        />
      </b-field>

      <b-field
        :label="$t('chapter7.q03c.text')"
        :type="
          store.getFieldError('datenweitergabe', `datenUebertragung.${index}.partnerDatenArt`)
            ? 'is-danger'
            : ''
        "
        :message="
          store.getFieldError('datenweitergabe', `datenUebertragung.${index}.partnerDatenArt`)
        "
      >
        <div v-for="option in partnerDatenArtOptions" :key="option">
          <b-checkbox
            :required="true"
            :native-value="option"
            v-model="ziel.partnerDatenArt"
            @change="save"
          >
            {{ $t(`chapter7.q03c.${option}`) }}
          </b-checkbox>

          <b-field
            v-if="ziel.partnerDatenArt?.includes('anonymisiert') && option === 'anonymisiert'"
            :type="
              store.getFieldError(
                'datenweitergabe',
                `datenUebertragung.${index}.partnerDatenArtAnonymisiertText`,
              )
                ? 'is-danger'
                : ''
            "
            :message="
              store.getFieldError(
                'datenweitergabe',
                `datenUebertragung.${index}.partnerDatenArtAnonymisiertText`,
              )
            "
          >
            <b-input
              :required="true"
              type="text"
              :placeholder="$t('chapter7.q03c.anonymisiertText')"
              v-model="ziel.partnerDatenArtAnonymisiertText"
              @blur="save"
            />
          </b-field>

          <b-field
            v-if="ziel.partnerDatenArt?.includes('idat') && option === 'idat'"
            :type="
              store.getFieldError(
                'datenweitergabe',
                `datenUebertragung.${index}.partnerDatenArtIdatText`,
              )
                ? 'is-danger'
                : ''
            "
            :message="
              store.getFieldError(
                'datenweitergabe',
                `datenUebertragung.${index}.partnerDatenArtIdatText`,
              )
            "
          >
            <b-input
              :required="true"
              type="text"
              :placeholder="$t('chapter7.q03c.idatText')"
              v-model="ziel.partnerDatenArtIdatText"
              @blur="save"
            />
          </b-field>
        </div>
      </b-field>

      <b-field
        v-if="partnerInternExtern === 'intern'"
        :label="$t('chapter7.q03a.text')"
        :type="
          store.getFieldError('datenweitergabe', `datenUebertragung.${index}.partnerInternZiel`)
            ? 'is-danger'
            : ''
        "
        :message="
          store.getFieldError('datenweitergabe', `datenUebertragung.${index}.partnerInternZiel`)
        "
      >
        <b-radio
          :required="true"
          native-value="klinet"
          v-model="ziel.partnerInternZiel"
          @change="save"
        >
          {{ $t('chapter7.q03a.klinet') }}
        </b-radio>
        <b-radio
          :required="true"
          native-value="winet"
          v-model="ziel.partnerInternZiel"
          @change="save"
        >
          {{ $t('chapter7.q03a.winet') }}
        </b-radio>
      </b-field>

      <template v-if="partnerInternExtern === 'extern'">
        <b-field
          :label="$t('chapter7.q03b.text')"
          :type="
            store.getFieldError('datenweitergabe', `datenUebertragung.${index}.partnerExternRegion`)
              ? 'is-danger'
              : ''
          "
          :message="
            store.getFieldError('datenweitergabe', `datenUebertragung.${index}.partnerExternRegion`)
          "
        >
          <b-radio
            :required="true"
            native-value="eu"
            v-model="ziel.partnerExternRegion"
            @change="save"
          >
            {{ $t('chapter7.q03b.eu') }}
          </b-radio>
          <b-radio
            :required="true"
            native-value="nonEu"
            v-model="ziel.partnerExternRegion"
            @change="save"
          >
            {{ $t('chapter7.q03b.nonEu') }}
          </b-radio>
        </b-field>

        <div v-if="ziel.partnerExternRegion === 'nonEu'" class="box mt-2">
          <p>
            {{ $t('chapter7.q03b.nonEu-text') }}
            <b-tooltip :label="$t(`general.showInfo`)" position="is-right" type="is-info">
              <b-icon
                type="is-info"
                icon="information-variant"
                class="info-toggle"
                :class="{ 'is-active': showInfo_c7q03b }"
                @click.native="showInfo_c7q03b = !showInfo_c7q03b"
              />
            </b-tooltip>
          </p>
          <NonEuInfo v-if="showInfo_c7q03b" />
          <b-field
            :type="
              store.getFieldError(
                'datenweitergabe',
                `datenUebertragung.${index}.partnerExternNonEu`,
              )
                ? 'is-danger'
                : ''
            "
            :message="
              store.getFieldError(
                'datenweitergabe',
                `datenUebertragung.${index}.partnerExternNonEu`,
              )
            "
          >
            <b-input
              type="textarea"
              rows="3"
              :placeholder="$t('chapter7.q03b.nonEuPlaceholder')"
              v-model="ziel.partnerExternNonEu"
              @blur="save"
            />
          </b-field>
        </div>
      </template>

      <b-field
        :label="$t('chapter7.q04.title')"
        :type="
          store.getFieldError('datenweitergabe', `datenUebertragung.${index}.uebertragungsArt`)
            ? 'is-danger'
            : ''
        "
        :message="
          store.getFieldError('datenweitergabe', `datenUebertragung.${index}.uebertragungsArt`)
        "
      >
        <div v-for="option in uebertragungsArtOptions" :key="option">
          <b-checkbox
            :required="true"
            :native-value="option"
            v-model="ziel.uebertragungsArt"
            @change="save"
          >
            {{ $t(`chapter7.q04.${option}`) }}
          </b-checkbox>

          <div class="box" v-if="ziel.uebertragungsArt?.includes('web') && option === 'web'">
            <b-field
              :type="
                store.getFieldError(
                  'datenweitergabe',
                  `datenUebertragung.${index}.uebertragungsArtWebText`,
                )
                  ? 'is-danger'
                  : ''
              "
              :message="
                store.getFieldError(
                  'datenweitergabe',
                  `datenUebertragung.${index}.uebertragungsArtWebText`,
                )
              "
            >
              <b-input
                :required="true"
                v-model="ziel.uebertragungsArtWebText"
                :placeholder="$t(`chapter7.q04.appWebseitePlaceholder`)"
                @blur="save"
              />
            </b-field>
            <b-field>
              <b-checkbox
                :required="true"
                v-model="ziel.uebertragungsArtWebLoeschung"
                type="is-success"
              >
                {{ $t(`chapter7.q04.loeschenNachUebertragung`) }}
              </b-checkbox>
            </b-field>
          </div>

          <div class="box" v-if="ziel.uebertragungsArt?.includes('cloud') && option === 'cloud'">
            <b-field
              :type="
                store.getFieldError(
                  'datenweitergabe',
                  `datenUebertragung.${index}.uebertragungsArtCloudText`,
                )
                  ? 'is-danger'
                  : ''
              "
              :message="
                store.getFieldError(
                  'datenweitergabe',
                  `datenUebertragung.${index}.uebertragungsArtCloudText`,
                )
              "
            >
              <b-input
                :required="true"
                v-model="ziel.uebertragungsArtCloudText"
                :placeholder="$t(`chapter7.q04.appWebseitePlaceholder`)"
                @blur="save"
              />
            </b-field>
            <b-field>
              <b-checkbox
                :required="true"
                v-model="ziel.uebertragungsArtCloudLoeschung"
                type="is-success"
              >
                {{ $t(`chapter7.q04.loeschenNachUebertragung`) }}
              </b-checkbox>
            </b-field>
          </div>

          <div
            class="box"
            v-if="ziel.uebertragungsArt?.includes('sonstige') && option === 'sonstige'"
          >
            <b-field
              :type="
                store.getFieldError(
                  'datenweitergabe',
                  `datenUebertragung.${index}.uebertragungsArtSonstige`,
                )
                  ? 'is-danger'
                  : ''
              "
              :message="
                store.getFieldError(
                  'datenweitergabe',
                  `datenUebertragung.${index}.uebertragungsArtSonstige`,
                )
              "
            >
              <b-input
                :required="true"
                v-model="ziel.uebertragungsArtSonstige"
                :placeholder="$t(`chapter7.q04.sonstigePlaceholder`)"
                @blur="save"
              />
            </b-field>
          </div>
        </div>
      </b-field>

      <template v-if="partnerInternExtern === 'extern'">
        <fieldset class="box">
          <legend>
            {{ $t('chapter7.q05.title') }}
            <b-tooltip :label="$t(`general.showInfo`)" position="is-right" type="is-info">
              <b-icon
                type="is-info"
                icon="information-variant"
                class="info-toggle"
                :class="{ 'is-active': showInfo_q05 }"
                @click.native="showInfo_q05 = !showInfo_q05"
              />
            </b-tooltip>
          </legend>

          <InfoText :button-label="$t('general.showInfo')" v-if="showInfo_q05">
            {{ $t('chapter7.q05.info') }}
            <MailtoLink user="FB16-Forschungsvertraege" domain="uni-frankfurt.de" />
          </InfoText>

          <b-field
            :type="
              store.getFieldError(
                'datenweitergabe',
                `datenUebertragung.${index}.datenweitergabeVertraglichGeregelt`,
              )
                ? 'is-danger'
                : ''
            "
            :message="
              store.getFieldError(
                'datenweitergabe',
                `datenUebertragung.${index}.datenweitergabeVertraglichGeregelt`,
              )
            "
          >
            <b-switch
              v-model="ziel.datenweitergabeVertraglichGeregelt"
              type="is-success"
              @input="onVertraglichGeregeltChange"
            >
              {{ $t('chapter7.q05.textCheckbox') }}
            </b-switch>
          </b-field>

          <b-field
            v-if="ziel.datenweitergabeVertraglichGeregelt === false"
            :label="$t('chapter7.q05.nichtGeregeltGrund')"
            :type="
              store.getFieldError(
                'datenweitergabe',
                `datenUebertragung.${index}.datenweitergabeNichtVertraglichGeregeltGrund`,
              )
                ? 'is-danger'
                : ''
            "
            :message="
              store.getFieldError(
                'datenweitergabe',
                `datenUebertragung.${index}.datenweitergabeNichtVertraglichGeregeltGrund`,
              )
            "
          >
            <b-input
              type="textarea"
              v-model="ziel.datenweitergabeNichtVertraglichGeregeltGrund"
              @blur="save"
            />
          </b-field>

          <div v-if="ziel.datenweitergabeVertraglichGeregelt === true">
            <p>{{ $t('chapter7.q05.text') }}</p>

            <div v-for="type in verhaeltnisOptions" :key="type">
              <b-checkbox
                v-model="ziel.verhaeltnisse"
                :native-value="type"
                @change="onVerhaeltnisseChange"
              >
                {{ $t(`chapter7.q05.${type}`) }}
              </b-checkbox>

              <b-field
                v-if="
                  type === 'vertragGemeinsameVerantwortung' &&
                  ziel.verhaeltnisse?.includes('vertragGemeinsameVerantwortung')
                "
                style="margin-left: 1rem"
              >
                <b-input
                  :required="ziel.verhaeltnisse?.includes('vertragGemeinsameVerantwortung')"
                  :placeholder="$t('chapter7.q05.vertragGemeinsameVerantwortung-placeholder')"
                  v-model="ziel.gemeinsamVerantwortlicheVertragsNr"
                  @blur="save"
                />
              </b-field>

              <b-field
                v-if="
                  type === 'auftragsverarbeitung' &&
                  ziel.verhaeltnisse?.includes('auftragsverarbeitung')
                "
                style="margin-left: 1rem"
              >
                <b-input
                  :required="ziel.verhaeltnisse?.includes('auftragsverarbeitung')"
                  :placeholder="$t('chapter7.q05.auftragsverarbeitung-placeholder')"
                  v-model="ziel.auftragsverarbeitungVertragsNr"
                  @blur="save"
                />
              </b-field>

              <b-field
                v-if="type === 'dta_mta' && ziel.verhaeltnisse?.includes('dta_mta')"
                style="margin-left: 1rem"
              >
                <b-input
                  :required="ziel.verhaeltnisse?.includes('dta_mta')"
                  :placeholder="$t('chapter7.q05.dta_mta-placeholder')"
                  v-model="ziel.dta_mtaVertragsNr"
                  @blur="save"
                />
              </b-field>

              <div
                v-if="
                  type === 'kooperationsvertrag' &&
                  ziel.verhaeltnisse?.includes('kooperationsvertrag')
                "
                style="margin-left: 1rem"
              >
                <b-field class="is-flex is-justify-content-flex-start">
                  <b-checkbox
                    v-model="ziel.kooperationsVertragGemeinsameVerantwortung"
                    type="is-success"
                  >
                    {{ $t('chapter7.q05.kooperationsvertrag-gemeinsameVerantwortung') }}
                  </b-checkbox>
                </b-field>
                <b-field>
                  <b-input
                    :required="ziel.verhaeltnisse?.includes('kooperationsvertrag')"
                    :placeholder="$t('chapter7.q05.kooperationsvertrag-placeholder')"
                    v-model="ziel.kooperationspartnerVertragsNr"
                    @blur="save"
                  />
                </b-field>
              </div>
            </div>

            <b-field :label="$t('chapter7.q05.sonstige')">
              <b-input v-model="ziel.verhaeltnisseSonstige" @blur="save" />
            </b-field>
          </div>
        </fieldset>
      </template>
  </fieldset>
</template>

<script setup lang="ts">
import { useStudyStore } from '@/stores/studyStore'
import { useInfoToggle } from '@/composables/useVisibilityToggles'
import type { DatenUebertragungsZiel } from '@/types/studyTypes'
import { BCheckbox, BField, BIcon, BInput, BRadio, BSwitch, BTooltip } from 'buefy'
import NonEuInfo from '@/components/NonEuInfo.vue'
import InfoText from '@/components/InfoText.vue'
import MailtoLink from '@/components/MailtoLink.vue'

const ziel = defineModel<DatenUebertragungsZiel>('ziel', { required: true })

defineProps<{
  index: number
  partnerInternExtern: 'intern' | 'extern'
}>()

const store = useStudyStore()

const partnerDatenArtOptions = ['pseudonymisiert', 'anonymisiert', 'idat']
const uebertragungsArtOptions = [
  'ecrf',
  'web',
  'cloud',
  'postalisch',
  'verschluesselteMail',
  'verschluesselteExterneApp',
  'gesicherterTransport',
  'verschluesselteExterneMedien',
  'telefonisch',
  'fax',
  'sonstige',
]

const save = () => {
  store.updateChapter('datenweitergabe', store.study.datenweitergabe)
}

const showInfo_q05 = useInfoToggle()
const showInfo_c7q03b = useInfoToggle()
const verhaeltnisOptions = [
  'kooperationsvertrag',
  'auftragsverarbeitung',
  'vertragGemeinsameVerantwortung',
  'dta_mta',
]

function onVertraglichGeregeltChange(event: Event) {
  const newValue = (event.target as HTMLInputElement).checked
  if (newValue) {
    ziel.value.datenweitergabeNichtVertraglichGeregeltGrund = undefined
    ziel.value.verhaeltnisse ??= []
  } else {
    ziel.value.verhaeltnisse = []
    ziel.value.gemeinsamVerantwortlicheVertragsNr = undefined
    ziel.value.auftragsverarbeitungVertragsNr = undefined
    ziel.value.kooperationsVertragGemeinsameVerantwortung = false
    ziel.value.kooperationspartnerVertragsNr = undefined
    ziel.value.dta_mtaVertragsNr = undefined
    ziel.value.verhaeltnisseSonstige = undefined
  }
  save()
}

function onVerhaeltnisseChange() {
  if (!(ziel.value.verhaeltnisse || []).includes('vertragGemeinsameVerantwortung')) {
    ziel.value.gemeinsamVerantwortlicheVertragsNr = undefined
  }
  if (!(ziel.value.verhaeltnisse || []).includes('auftragsverarbeitung')) {
    ziel.value.auftragsverarbeitungVertragsNr = undefined
  }
  if (!(ziel.value.verhaeltnisse || []).includes('dta_mta')) {
    ziel.value.dta_mtaVertragsNr = undefined
  }
  if (!(ziel.value.verhaeltnisse || []).includes('kooperationsvertrag')) {
    ziel.value.kooperationsVertragGemeinsameVerantwortung = false
    ziel.value.kooperationspartnerVertragsNr = undefined
  }
  save()
}
</script>

<style scoped></style>
